import { api } from '../../app/api/baseApi';
import { PAGINATION_PAYLOAD } from '../../constants/paginationQuery';

// The Reports service is mounted at /reports/v1 on API_URL, not under /api/v1.
const REPORTS_SERVICE_PATH = 'reports/v1';

const reportsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getAllMonthlyReports: builder.query<object, any>({
            query: (body) => ({
                url: `${REPORTS_SERVICE_PATH}/monthlyreport`,
                body: body,
                method: 'POST',
            }),
        }),
        downloadMonthlyReportFile: builder.mutation<Blob, string>({
            query: (fileId) => ({
                url: `${REPORTS_SERVICE_PATH}/monthlyreportfile`,
                method: 'GET',
                params: { fileId },
                responseHandler: (response): Promise<Blob> => response.blob(),
            }),
        }),

        getMobileReports: builder.query<any, any>({
            query: (body) => {
                const payloadClone = JSON.parse(JSON.stringify(body));
                if (payloadClone.pullRefresh) {
                    delete payloadClone.pullRefresh;
                }
                return {
                    url: `${REPORTS_SERVICE_PATH}/monthlyreport`,
                    method: 'POST',
                    body: payloadClone,
                };
            },
            ...PAGINATION_PAYLOAD,
        }),
    }),
});

export const { useGetAllMonthlyReportsQuery, useGetMobileReportsQuery, useDownloadMonthlyReportFileMutation } =
    reportsApi;
